import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpCheckBox from "../../common/AmpCheckBox/AmpCheckBox";
import AmpDropdown from "../../common/AmpDropdown/AmpDropdown";
import SmallHeading from "../../common/AmpSmallHeading/AppSmallHeading";
import { FormRegTabs } from "../RegistrationTypes";
import AmpInfoWrapper from "../../common/AmpInfoWrapper/AmpInfoWrapper";
import styles from "./Preferences.module.css";
import AmpWarning from "../../common/AmpWarning/AmpWarning";
import AmpToolTip from "../../common/AmpToolTip/AmpToolTip";

export interface EnotifSettings {
    defaultValue: boolean;
    isAllowed: boolean;
}

interface LanguageProps extends FormRegTabs {
    setLanguageValid: React.Dispatch<React.SetStateAction<boolean>>;
    registerUserEvent: () => void;
    enotifSettings: EnotifSettings
}

export default function Language(props: LanguageProps) {

    const { t } = useTranslation('login');

    const [language, setLanguage] = useState("0");
    const languageValid = language !== "0";

    const [enotifOverride, setEnotif] = useState<boolean>(props.enotifSettings.defaultValue);

    const changeLanguageDropdown = (value: string) => {
        const payload = { ...props.payload }
        payload.lang_pref = value;
        props.setPayload(payload);
        setLanguage(value);
        if (value !== "0") {
            props.setLanguageValid(true);
        }
    };

    const languageAria = "lang-aria";
    const enotifAria = "e-aria";

    const handleNext = () => {
        if (enotifOverride) {
            props.setActiveTab(5);
        } else {
            const payload = { ...props.payload };
            payload.enotif = false;
            props.setPayload(payload);
            props.setActiveTab(6);
        }

        return;
    }

    return (
        <>
            <div className="dark-blue-background">
                {t('4-top-text') as string}
            </div>
            <div className="login-container-mid">
                <AmpInfoWrapper showIcon={false}>
                    <div className={`${!props.enotifSettings.isAllowed && styles.readonlyEnotif}`}>
                        <SmallHeading for={enotifAria}>
                            {t("4-enotif-heading")}
                        </SmallHeading>
                        <p>
                            <Trans defaults={t("4-enotif-message")}>
                                <sup></sup>
                            </Trans>
                        </p>
                        <br />
                        <div className={styles.enotifCheckbox}>
                            <AmpCheckBox
                                isSlider={true}
                                handleCheck={(e) => { setEnotif((e.target as HTMLInputElement).checked) }}
                                id={enotifAria}
                                hasToolTip={!props.enotifSettings.isAllowed}
                                toolTip={t("enotif-not-allowed")}
                                label={""}
                                defaultChecked={props.enotifSettings.defaultValue}
                                disabled={!props.enotifSettings.isAllowed}
                                tooltipAlign="left-text"
                            />
                        </div>
                        <AmpWarning show={!enotifOverride && props.enotifSettings.isAllowed}>
                            {t('7-attest-1')}
                            <AmpToolTip textDirection="left-text" id={"warnenotif"} content={`${t('7-attest-2')}`} size="lg" />
                        </AmpWarning>
                    </div>
                </AmpInfoWrapper>
                <br />
                <AmpInfoWrapper showIcon={false}>
                    <SmallHeading for={languageAria}>
                        {t("4-lang-heading")}
                    </SmallHeading>
                    <p>
                        <Trans defaults={t('4-para-1')}>
                            {/* eslint-disable-next-line */}
                            <sup></sup>
                        </Trans>
                    </p>
                    <p>
                        <Trans defaults={t('4-para-2')}>
                            {/* eslint-disable-next-line */}
                            <sup></sup>
                        </Trans>
                    </p>

                    <AmpDropdown
                        id={languageAria}
                        onChange={(e) => changeLanguageDropdown((e.target as HTMLOptionElement).value)}
                        options={
                            [
                                {
                                    value: "0",
                                    text: t('4-select')
                                },
                                {
                                    value: "en_EN",
                                    text: t('4-english')
                                },
                                {
                                    value: "fr_FR",
                                    text: t('4-french')
                                }
                            ]
                        }
                    />
                </AmpInfoWrapper>
            </div>

            <br />
            <div className="login-container-footer">
                <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                <div>
                    <AmpButton type="cancel" onClick={() => props.triggerCancel(true)} text={t("cancel")} />
                    <AmpButton type="cancel" onClick={() => props.setActiveTab(3)} text={t("back")} />
                    {(props.enotifSettings.isAllowed && enotifOverride) && <AmpButton type="submit" onClick={() => handleNext()} text={t("next")} disabled={!languageValid} />}
                    {(!props.enotifSettings.isAllowed || !enotifOverride) && <AmpButton type="submit" onClick={() => props.registerUserEvent()} text={t("4-create")} disabled={!languageValid} />}
                </div>
            </div>
        </>
    )
}